import { createSlice } from '@reduxjs/toolkit';

const STORAGE_KEY = 'cashSession';

// Persist minimal session info to localStorage for instant restore on refresh.
// Full summary is always re-fetched from API on mount.
const persistSession = (session) => {
  if (!session) {
    localStorage.removeItem(STORAGE_KEY);
    return;
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify({
    id:               session.id,
    pos_terminal_id:  session.pos_terminal_id ?? null,
    terminal_name:    session.terminal_name ?? null,
    status:           session.status,
    session_number:   session.session_number,
    opening_balance:  session.opening_balance,
    closing_balance:  session.closing_balance ?? null,
    opened_at:        session.opened_at,
    closed_at:        session.closed_at ?? null,
  }));
};

const cashSessionSlice = createSlice({
  name: 'cashSession',
  initialState: {
    currentSession: null,
    // currentSession shape (full, after API fetch):
    // {
    //   id, session_number, status,
    //   opening_balance, closing_balance,
    //   opened_at, closed_at,
    //   summary: {
    //     total_cash_sales, total_change_given,
    //     total_cash_refunds, total_cash_ins,
    //     total_cash_outs, expected_cash, cash_difference
    //   }
    // }
  },
  reducers: {
    setCurrentSession: (state, { payload }) => {
      state.currentSession = payload;
      persistSession(payload);
    },
    clearCurrentSession: (state) => {
      state.currentSession = null;
      localStorage.removeItem(STORAGE_KEY);
    },
  },
});

export const { setCurrentSession, clearCurrentSession } = cashSessionSlice.actions;
export default cashSessionSlice.reducer;
